import { Button } from "@jem-open/jem-ui";
import React from "react";
import PageHeading from "../../../../themes/components/PageHeading";
import { useLogout } from "../../../../hooks/useLogout";

const SettingsHeader: React.FC = () => {
  const logout = useLogout();

  return (
    <PageHeading title="Account Settings">
      <Button
        type="button"
        variant="primary"
        className="inline-flex"
        onClick={() => logout(false)}
      >
        Logout
      </Button>
    </PageHeading>
  );
};

export default SettingsHeader;
